import { gql } from '@apollo/client';

// Header navigation menus in one backend query. Items come back flat;
// HeaderProvider reshapes them into the collection shape the menus render.
export const LOAD_HEADER_DATA = gql`
  query HeaderData(
    $neighborhoodSearch: String
    $buildingSearch: String
    $buildingPage: Int
    $loadNhds: Boolean!
    $loadBuildings: Boolean!
  ) {
    headerData(
      neighborhoodSearch: $neighborhoodSearch
      buildingSearch: $buildingSearch
      buildingPage: $buildingPage
      loadNeighborhoods: $loadNhds
      loadBuildings: $loadBuildings
    ) {
      neighborhoods {
        total
        items {
          id
          name
          slug
          cityName
          citySlug
          countyId
          countyName
        }
      }
      buildings {
        page
        total
        items {
          id
          name
          slug
          neighborhoodName
          neighborhoodSlug
        }
      }
    }
  }
`;

export const GET_LAST_LISTING_UPDATED = gql`
  query LastListingUpdated {
    lastListingUpdate {
      data {
        attributes {
          lastListingUpdate
        }
      }
    }
  }
`;
